import classNames from 'classnames';
import {ReactNode} from 'react';
import verifiedSign from '../../../../assets/image/verified_sign.svg';
import {useSafeNavigateBack} from '../../../../pages/farm/myStore/pages/myStoreAdvertisement/useSafeNavigate';
import {googleAnalyticsInstance} from '../../../../utilities/helper/googleAnalitics';

interface ShareTitleHeaderProps {
  title?: string;
  backRoute?: string;
  isLiked?: boolean;
  onClickLike?: () => void;
  isSaleAgent?: boolean;
  hideShareIcon?: boolean;

  /** Optional component rendered next to Share & Like */
  rightExtra?: ReactNode;
}

const ShareTitleHeader = ({
  title,
  isLiked,
  onClickLike,
  isSaleAgent,
  hideShareIcon,
  backRoute,
  rightExtra,
}: ShareTitleHeaderProps) => {
  const safeNavigateBack = useSafeNavigateBack(backRoute ?? '/home');
  const eventShare: IGoogleEvent = {
    category: 'share-icon-clicked',
    action: 'آیکن اشتراک گذاری کلیک شد',
  };

  const handleShareButton = () => {
    googleAnalyticsInstance.eventGoogleAnalytics(eventShare);

    if (navigator.share) {
      navigator.share({
        url: window.location.href,
        title,
      });
    }
  };

  return (
    <header>
      <div className="flex shadow-sm text-md text-gray-800 h-[56px] bg-white px-3 w-full justify-between items-center">
        {/* LEFT */}
        <div className="flex gap-2 items-center text-gray-800 text-md">
          <i
            className="icon-nameArrow---Right text-[25px] cursor-pointer"
            onClick={() => {
              safeNavigateBack();
            }}
          />
          <div className="line-clamp-1">{title}</div>
          {isSaleAgent && (
            <img src={verifiedSign} alt="verified sign" className="w-4" />
          )}
        </div>

        {/* RIGHT */}
        {!hideShareIcon && (
          <div className="flex gap-2 items-center text-gray-800">
            {rightExtra && (
              <div className="flex items-center">{rightExtra}</div>
            )}

            <i
              className="icon-size24102 text-[25px] cursor-pointer"
              onClick={handleShareButton}
            />

            <i
              onClick={onClickLike}
              className={classNames('cursor-pointer text-[25px]', {
                'icon-namefavourite': !isLiked,
                'text-red-600 icon-namefavourite1': isLiked,
              })}
            />
          </div>
        )}
      </div>
    </header>
  );
};

export default ShareTitleHeader;
